import Orbit from "./orbit.mjs";

var Kepler = {};

Kepler.Orbit = Orbit;

export default Kepler;
